<template>
    <div class="pdf-box">
        <img src="../assets/capa_livro_padrao.jpeg" alt="Capa do PDF" class="pdf-cover" />
        <div class="pdf-info">
            <span class="pdf-title">{{ discipline.nome_disciplina }}</span>
            <div class="btn-class">
                <router-link
                    class="pdf-link"
                    :to="{
                        path: '/classes',
                        query: { discipline: discipline.codigo_disciplina }
                    }"
                >
                    Ver disciplina
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import '../styles/CardBook.css';
import { RouterLink } from 'vue-router';

export default {
    name: 'CardDiscipline',
    components: {
        RouterLink
    },
    props: {
        discipline: {
            type: Object,
            required: true
        }
    },
    methods: {
        getCoverUrl(cover) {
            return cover;
        }
    }
};
</script>